const educationData = [
    {
        key: "graduate",
        heading: "Graduate",
        subHeading: "Masters in Software Engineering Systems",
        content: [
            "Northeastern University, Boston",
            `Relevant Coursework: Enterprise Software Engineering, Network Structures and Cloud Computing, Advanced Big Data App/Indexing, 
            Concepts of Object Oriented Design, Program Structures and Algorithms, Web Design & User
            Experience Engineering, User Experience Design & Testing, and
            Data Management and Database Design`,
            "GPA: 3.77"
        ],
        dateRange: "Sep 2022 - May 2024",
        isRoundTop: true,
        isRoundBottom: false
    },
    {
        key: "undergraduate",
        heading: "Undergraduate",
        subHeading: "Bachelor of Technology (B.Tech) in Computer Science",
        content: [
            "BML Munjal University, Haryana, India",
            `Relevant Coursework: Design and Analysis of Algorithms, Database Systems, Computer Networks, Software Engineering, Human Computer Interaction`,
            "CGPA (on scale of 10): 7.92"
        ],
        dateRange: "Aug 2015 - Aug 2019",
        isRoundTop: false,
        isRoundBottom: false
    },
    {
        key: "higherSecondary",
        heading: "Higher Secondary School (12th Standard)",
        subHeading: "Higher Secondary Certificate (Non-Medical) ",
        content: [
            "Summer Fields School, Gurgaon, Haryana, India",
            "Percentage: 75.4%"
        ],
        dateRange: "May 2015",
        isRoundTop: false,
        isRoundBottom: false
    },
    {
        key: "seniorSchool",
        heading: "Secondary School (10th Standard)",
        subHeading: "Secondary School Certificate",
        content: [
            "Summer Fields School, Gurgaon, Haryana, India",
            "CGPA (on scale of 10): 9.2"
        ],
        dateRange: "May 2013",
        isRoundTop: false,
        isRoundBottom: true
    }
];

export default educationData;